// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__37-sK","subheader":"ReorderModal_subheader__v3lDj","listWrap":"ReorderModal_listWrap__1xLs_"};